import {inject, Injectable} from "@angular/core";
import {UrlService} from "../../../../core/services/url.service";
import {ErrorHandlingService} from "../../../../core/services/error.handling.service";
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, Observable, tap} from "rxjs";
import {AppointmentConfirmationDTO} from "./appointment-confirmation-types";
import {UrlEnum} from "../../../../core/types/url-enum";
import {ObservableErrHandler} from "../../../../core/types/err.handling.types";
import {CalendarEventResponse} from "../../../../core/types/calendar.types";
import {DomSanitizer} from "@angular/platform-browser";


@Injectable({providedIn: 'root'})
export class AppointmentConfirmService
{
    private readonly _urlService: UrlService = inject(UrlService);
    private readonly _errHandlService: ErrorHandlingService = inject(ErrorHandlingService);
    private readonly _httpClient: HttpClient = inject(HttpClient);

    private readonly _busy: BehaviorSubject<boolean> = new BehaviorSubject(false);

    get busy$() {
        return this._busy.asObservable();
    }

    /**
     * Constructor
     */
    constructor() {

    }

    getConfirmationDto(token:string):Observable<AppointmentConfirmationDTO> {
        this._busy.next(true);
        const obs = this._httpClient.get<AppointmentConfirmationDTO>(
            this._urlService.getUrl(UrlEnum.private_appointment_confirm_get).replace("{token}",token));

        obs.pipe(tap({
                next: value => {

                },
                error: err => {
                    this._busy.next(false);
                },
                complete: () => {
                    this._busy.next(false);
                }
            }
        ));

        return obs;
    }

    cancelAppointment(token:string, status:CalendarEventResponse):Observable<AppointmentConfirmationDTO> {
        this._busy.next(true);
        const obs = this._httpClient.get<AppointmentConfirmationDTO>(
            this._urlService.getUrl(UrlEnum.private_appointment_decline)
                .replace("{token}",token)
                .replace("{reason}",status)
        );

        obs.pipe(tap({
                next: value => {

                },
                error: err => {
                    this._busy.next(false);
                },
                complete: () => {
                    this._busy.next(false);
                }
            }
        ));

        return obs;
    }

    confirmAppointment(token:string):Observable<AppointmentConfirmationDTO> {
        this._busy.next(true);
        const obs = this._httpClient.get<AppointmentConfirmationDTO>(
            this._urlService.getUrl(UrlEnum.private_appointment_confirm)
                .replace("{token}",token)
        );

        obs.pipe(tap({
                next: value => {

                },
                error: err => {
                    this._busy.next(false);
                },
                complete: () => {
                    this._busy.next(false);
                }
            }
        ));

        return obs;
    }

}
